import { Component, Vue, Watch } from "vue-property-decorator";
import { DeliveryModel, DeliveryMethodModel, ChangeDeliveryMethod, CheckoutTranslationModel as TranslationModel} from "../models/deliveryModel";
import { KlarnaCheckoutApi, KlarnaCheckout, KlarnaCheckoutWidget } from "@/models/KlarnaCheckout";
import GoogleEnhancedEcommerce from "../services/GoogleEnhancedEcommerce";
import http from "../services/Http";
import HandlingFeeMessageCart from "./HandlingFeeMessageCart";
import { deliveriesStore } from "@/store/DeliveriesModule";
import { EventBus } from "../events";
import ResellerOrderCheckout from "../modules/ResellerOrderCheckout/ResellerOrderCheckout";

@Component({
    components: {
        ResellerOrderCheckout
    }
})
export default class DeliverySelector extends Vue {
    protected translations: TranslationModel;
    private postalCode: string = "";
    private deliveries: DeliveryModel[] = new Array<DeliveryModel>();
    private selectedDelivery: any = null;
    private widget: any = null;
    private showDeliveries: boolean = false;
    private forceKlarnaRerender: boolean = false;
    private handlingFeeMessage: string = "";
    private handlingFeeMessageInCart: string = "";
    private showResellerCheckout: boolean = false;
    private isLoading: boolean = false;
    private disableDays: string = "";
    private saveonChange: any = false;
    private klarnaValidationFailed: boolean = false;

    private url: string = window.location.origin + window.location.pathname;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }
    protected created() {
        this.disableDays = this.$attrs.disabledays;
        this.saveonChange = this.$attrs.saveonchange;

        this.klarnaValidationFailed = window.location.href.indexOf("validateFailed") > -1;
        if (this.$attrs.deliverypostalcode !== "" && this.klarnaValidationFailed) {
            this.postalCode = this.$attrs.deliverypostalcode;
            this.onClick(true);
        }
    }
    get deliveryMethodsAvailable(): boolean {
        return this.deliveries && this.deliveries.length > 0;
    }

    protected mounted() {
        EventBus.$on("refreshDeliverySelector", (variantId: string) => {
            if (deliveriesStore.deliveries.postalCode !== undefined) {
                this.onClick();
            }
        });

        if (this.klarnaValidationFailed) {
            const element = document.getElementById("dvValidateFailed");
            if (element) {
                window.scrollTo(0, element.offsetTop);
            }
        }
    }

    @Watch("selectedDelivery")
    protected onSelectedDeliveryChange(value: string, oldValue: string) {
        this.changeDeliveryMethod(value);
    }

    protected changeDeliveryMethod(value: string) {
        if (window._klarnaCheckout) {
            window._klarnaCheckout((api: KlarnaCheckoutApi) => {
                api.suspend();
            });
        }

        this.isLoading = true;
        http.post<ChangeDeliveryMethod>(`${this.url}.ChangeDeliveryMethod?deliveryMethodId=${value}`)
        .then(response => response).then(data => {
            if (data.isResellerCheckout) {
                this.showResellerCheckout = true;
            } else {
                this.getKlarnaCheckout();
            }
        });
        this.isLoading = false;
    }

    protected getKlarnaCheckout() {
        http.get<KlarnaCheckoutWidget>(`${this.url}.GetKlarnaCheckout`)
        .then(r => {
            if (window._klarnaCheckout && !this.forceKlarnaRerender) {
                window._klarnaCheckout((api: KlarnaCheckoutApi) => {
                    api.resume();
                });
            } else {
                $("#klarna-widget").append(r.widget);
                if (this.forceKlarnaRerender) {
                    this.forceKlarnaRerender = false;
                }
            }

            this.isLoading = false;
        });
    }

    protected onClick(fromCreated: boolean = false): void {
        if (this.postalCode && this.postalCode.length > 0) {
            this.ReportPostalCodeToGoogleEnhancedEcommerce();
            this.isLoading = true;
            const previousNofDeliveryMethods = this.deliveries ? this.deliveries.length : 0;
            http.get<DeliveryMethodModel>(`${this.url}.GetDeliveryMethods?postalCode=${this.postalCode}`)
                .then(r => {
                    this.showDeliveries = true;
                    this.deliveries = r.deliveryMethods;
                    if (fromCreated !== true) {
                        this.klarnaValidationFailed = false;
                    }

                    if (this.deliveries.length === 1) {
                        this.selectedDelivery = this.deliveries[0].id;
                        this.handlingFeeMessage = this.deliveries[0].handlingFeeMessage;
                        this.handlingFeeMessageInCart = this.deliveries[0].handlingFeeMessageInCart;
                        deliveriesStore.dispatchDeliveries(this.deliveries[0]);
                        deliveriesStore.dispatchTotalValueOfGoods(this.deliveries[0].totalValueOfGoods);
                        this.forceKlarnaRerender = true;
                    }

                    if (this.deliveryMethodsAvailable && previousNofDeliveryMethods === 0) {
                        this.forceKlarnaRerender = true;
                        if (this.deliveries.length === 1) {
                            this.changeDeliveryMethod(this.selectedDelivery);
                        }
                    }
                    if (r.isResellerCheckout && this.deliveryMethodsAvailable) {
                        this.showResellerCheckout = true;
                        if (window.eventBus && this.deliveries.length > 0) {
                            EventBus.$emit("initMapSearch", this.deliveries[0].postalRegion);
                        }
                    } else {
                        this.showResellerCheckout = false;
                        this.getKlarnaCheckout();
                    }
                    this.isLoading = false;
                })
                .catch(err => console.error(err));
        }
    }
    private ReportPostalCodeToGoogleEnhancedEcommerce() {
        const gee = new GoogleEnhancedEcommerce();
        gee.PushPostalCodeToGoogle(this.postalCode);
    }
}
